$(function(){
    // using our own bootstrap offcanvas evocation so that we can control the behavior of certain elements
    var offcanvas_selector = document.getElementById('mega-menu');
    var offcanvas = new bootstrap.Offcanvas(offcanvas_selector);
    $('button.mm-btn-open').on('click', function() {
        offcanvas.show();
    })
    $('button.mm-btn-close').on('click', function(){
        if($('input.gsc-input').val().length <= 0 && offcanvas._isShown){
            offcanvas.hide();
        }else{
            //transform x into bars
            $('a.gsst_a').trigger('click');
            $('.close-button-wrapper').children().removeClass('fa-xmark').addClass('fa-bars');            
        }
    });
    $(document).on('keyup', function(e){
        /**
         * 13 is the Enter Key. So we only do a transformation with keyboard controls iff:
         * 1. The User hits the enter key.
         * 2. The Offcanvas is shown.
         * 3. The input field for the google search engine is populated, indicating focus. 
        */
        if(e.which == 13 && offcanvas._isShown && $('input.gsc-input').val().length > 0){
            $('.close-button-wrapper').children().removeClass('fa-bars').addClass('fa-xmark');
        }
    });
    $(document).on('click', 'button.gsc-search-button', function(e) {
        /* Had to use universal click capture with event data to avoid async issues */
        if($('input.gsc-input').val().length > 0){
            $('.close-button-wrapper').children().removeClass('fa-bars').addClass('fa-xmark');
        }
    });
    $('.mm-nav-item').on('mouseenter', function(e){
        if($(window).width() > 992){
            $('.mm-nav.active').parent().siblings('.arrow-container').removeClass('active-tab');
            $(this).children('.mm-btn-group').children('.mm-nav').trigger('click');
            $(this).children('.mm-btn-group').siblings('.arrow-container').addClass('active-tab');
        }
    }).on('mouseleave', function(e){
        console.log($(this).parent());
        // if(!$(this).children('.mm-nav').hasClass('active')){
        // }
    });
});